export const isObjectEmpty = (object: any = {}) => {
  for (const _ in object) {
    return false;
  }

  return true;
};
